import "./index.scss";
import MapDetail from "../mapDetail";
import { useClientLayout } from "../../../../hooks";
import { useContextData } from "../../data-context";
import { useMemo } from "react";
interface IProps {
  className?: string;
  style?: React.CSSProperties;
  right?: string;
  middle?: string;
  left?: string;
  marks?: string[];
  text: string;
  id?: any;
  markColor?: string;
  markScale?: number;
  isPC: boolean;
  bubblesNumer?: number;
  onClick?: (data: any) => void;
}

const Bubble = (props: IProps) => {
  const {
    contextData: { addressName },
    setContextData,
  } = useContextData();
  const {
    className,
    style,
    right: rightImage,
    middle: middleImage,
    left: leftImage,
    marks,
    text,
    id,
    markColor,
    markScale = 1,
    isPC,
    bubblesNumer,
    onClick,
  } = props;

  const scale = 1 / markScale;

  const { targetRef, width, height } = useClientLayout();
  const { left = 0, top = 0, ...restStyle } = style as any;

  const open = addressName === text;
  const detailId = parseInt(id);
  // const number = parseInt(bubblesNumer)
  let bubbleWrapStyle = {
    ...restStyle,
    left: `calc(${left} - ${width / 2}px)`,
    top: `calc(${top} - ${height / 2}px)`,
    zIndex: open ? 20 : 10,
  };

  if (!isPC) {
    bubbleWrapStyle = {
      ...bubbleWrapStyle,
      transform: `scale(${markScale * 0.5})`,
    };
  }
  const mapNumber = bubblesNumer as any;
  const showBubble = useMemo(() => {
    if (isPC) {
      return scale > 2 || mapNumber <= 10;
    } else {
      return scale > 8 || mapNumber <= 10;
    }
  }, [isPC, scale]);
  return (
    <div
      ref={targetRef}
      className={`bubbleWrap  ${className}`}
      style={bubbleWrapStyle}
      onClick={() => {
        setContextData({ addressName: text });
        onClick?.({ name: text, id });
      }}
    >
      {marks && (
        <div className="markWrap">
          {marks?.map((item, index) => (
            <div
              key={index}
              className="markItem"
              style={{ background: markColor }}
            >
              <i className={`iconfont ${item}`}></i>
            </div>
          ))}
        </div>
      )}
      <div className={`bubble`} style={{ visibility: showBubble ? "visible" : "hidden" }}>

        <div className="bubbleBg">
          <img className="left" src={leftImage} alt="" />
          <img className="middle" src={middleImage} alt="" />
          <img className="right" src={rightImage} alt="" />
        </div>
        <div className="text">{text}</div>
      </div>
      {isPC && (
        <MapDetail
          open={open}
          detailId={detailId}
          onClose={() => {
            setContextData({ addressName: "" });
          }}
        ></MapDetail>
      )}
    </div>
  );
};

export default Bubble;
